<div class="card">
<div class="control-section chat-ui">
    <div class="default-chatui">
        <div id="chatUser1" ejs-chatui #chatUi [messages]="chatMessage" height="70vh" [user]="chatUser" [loadOnDemand]="true"
          [showHeader]="false" [messageToolbarSettings]="messageToolbarSettings" (messageSend)="onMessageSend($event)">
          <ng-template #emptyChatTemplate>
            <div class="empty-chat-text"><h4><span class="e-icons e-comment-show"></span></h4><h4>No comments yet</h4><p>Start a conversation to see your comments here.</p></div>
          </ng-template>
        </div>
    </div>
</div>    
</div>
